module.exports = __webpack_public_path__ + "static/img/qznn_3d_banner.f1eb2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/qznn_3d_banner.png
// module id = Abqo
// module chunks = 0